import "../io/CampaignDetailsIO.css";
import { ReactComponent as Logo } from "../../../assests/amp_logo.svg";
import {
  Col,
  Divider,
  Image,
  Row,
  Spin,
  Table,
} from "../../common/utils/antd-imports/AntdImports";
import dayjs from "dayjs";
import { API_BASE_URL_IMAGE } from "../../../services/common";
import { formatBillboardSize, formatToUSCurrency } from "../utils/Utils";

const CampaignDetailsQuote = ({ campaignDetails, pdfLoader }) => {
  const columns = [
    {
      title: "SI no.",
      dataIndex: "slno",
      align: "center",
      width: 50,
    },
    {
      title: "Product ID & Title",
      dataIndex: "productIdAndTitle",
      align: "left",
      width: 200,
    },
    {
      title: "Type",
      dataIndex: "type",
      align: "left",
      width: 80,
    },
    {
      title: "Product Location",
      dataIndex: "billboardLoc",
      align: "left",
      width: 150,
    },
    {
      title: "Size",
      dataIndex: "size",
      align: "center",
      width: 120,
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      align: "left",
      width: 100,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      align: "left",
      width: 100,
    },
    {
      title: "Days",
      dataIndex: "days",
      align: "center",
      width: 80,
    },
    {
      title: "Unit Price($)",
      dataIndex: "unitPrice",
      align: "right",
      width: 100,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "center",
      width: 80,
    },
    {
      title: "Product Price($)",
      dataIndex: "productPrice",
      align: "right",
      width: 150,
    },
    {
      title: "Tax Amount($)",
      dataIndex: "taxAmount",
      align: "right",
      width: 150,
      render: (text) => text,
    },
    {
      title: "Installation + Production Price ($)",
      dataIndex: "installationAndProductionPrice",
      align: "right",
      width: 220,
    },
    {
      title: "Net Total($)",
      dataIndex: "netTotal",
      align: "right",
      width: 150,
    },
  ];
  const data = campaignDetails?.products?.map((product, index) => ({
    slno: (index + 1).toString(),
    productIdAndTitle: `${product?.siteNo} ${product?.title}`,
    type: product?.type,
    billboardLoc: product?.city_name || "N/A",
    size:
      formatBillboardSize(product?.width) +
        " X " +
        formatBillboardSize(product?.height) || "N/A",
    startDate: dayjs(product?.booked_from).format("MM-DD-YYYY") || "N/A",
    endDate: dayjs(product?.booked_to).format("MM-DD-YYYY") || "N/A",
    days:
      product?.booked_from && product?.booked_to
        ? dayjs(product?.booked_to).diff(dayjs(product?.booked_from), "day") + 1
        : "N/A",
    unitPrice: formatToUSCurrency(Number(product?.price)?.toFixed(2) || 0),
    quantity: product?.quantity || 0,
    productPrice: formatToUSCurrency(Number(product?.price)?.toFixed(2) || 0),
    taxAmount: (
      <>
        ({product?.tax_percentage}%)
        <br />
        {(Number(product?.tax_percentage_amount) || 0).toFixed(2)}
      </>
    ),
    installationAndProductionPrice:
      `${formatToUSCurrency(
        Number(product?.install_cost_price)?.toFixed(2)
      )} + ${formatToUSCurrency(
        Number(product?.production_cost_price)?.toFixed(2)
      )} ` || 0,
    netTotal: product?.owner_price
      ? `${formatToUSCurrency(
          Number(
            product?.owner_price +
              product?.tax_percentage_amount +
              product?.install_production_cost
          )?.toFixed(2)
        )}`
      : `${formatToUSCurrency(
          Number(
            (product?.price || 0) * (product?.quantity || 1) +
              product?.tax_percentage_amount +
              product?.install_production_cost
          )?.toFixed(2)
        )}` || 0,
  }));

  return (
    <>
      <div className="view-io-main-content-div">
        <Row className="io-container-sub-div">
          <Col>
            <Logo className="io-logo-css" />
          </Col>
        </Row>
        <Col>
          <div className="io-col-sub-div">
            <span
              className="io-campaign-details-row-text"
              style={{
                textAlign: "center",
              }}
            >
              Quote for Campaign
            </span>
          </div>
        </Col>
        <Row className="io-campaign-details-row">
          <Col>
            <div className="io-col-sub-div" style={{display:"flex"}}>
              <span
                className="io-campaign-details-row-text"
                style={{
                  textAlign: "left",
                }}
              >
                Campaign Details
              </span>
              <span className="view-io-text view-io-left-alignment">
                {`Campaign Name: ${campaignDetails?.name}`}
              </span>
              <span className="view-io-text view-io-left-alignment">
                {` Start Date: ${campaignDetails?.startDate ?? 'N/A'}`}
              </span>
              <span className="view-io-text view-io-left-alignment">
                {` End Date: ${campaignDetails?.endDate ?? 'N/A'}`}
              </span>
              <span className="view-io-text view-io-left-alignment">
                {` Total Duration: ${campaignDetails?.totalDays ?? '0'} days`}
              </span>
              <span className="view-io-text view-io-left-alignment">
                Target Audience:
              </span>
              <span className="view-io-text view-io-left-alignment">
                Objective:
              </span>
            </div>
          </Col>

          <Col>
            <div className="io-col-sub-div">
              <span
                className="io-campaign-details-row-text"
                style={{
                  textAlign: "end",
                }}
              >
                <br></br>
              </span>
              <span className="view-io-text view-io-left-alignment">
                {`Date: ${dayjs().format("MM-DD-YYYY")}`}
              </span>
              <span className="view-io-text view-io-left-alignment">
                {`IO Number: ${campaignDetails?.id}`}
              </span>
            </div>
          </Col>
        </Row>

        <Col style={{ marginTop: "2.7rem" }}>
          <span
            className="io-campaign-details-row-text"
            style={{
              textAlign: "end",
            }}
          >
            Selected Products & Pricing
          </span>
        </Col>
        <Col style={{ marginTop: "1rem" }}>
          <Table
            columns={columns}
            dataSource={data}
            className="view-io-table"
            tableLayout="fixed"
            pagination={false}
          />
        </Col>

        <Row className="quote-impressions-div">
          <Col className="quote-impressions-col">
            {`Impressions Total - ${isNaN(Number(
              campaignDetails?.impressionSum
            )) ? 0 : Number(
              campaignDetails?.impressionSum.toFixed(2))}`}
          </Col>
          <Col className="quote-impressions-col">
            {" "}
            {`CPM Total - ${formatToUSCurrency(
              Number(campaignDetails?.campaign_cpmval).toFixed(2)
            )}`}
          </Col>
          <Col className="quote-impressions-col">
            {`Total - ${formatToUSCurrency(
              Number(campaignDetails?.act_budget).toFixed(2)
            )}`}
          </Col>
        </Row>
        {campaignDetails?.products?.map((product, index) => (
          <>
            {index === 0 && <Divider className="quote-divider"></Divider>}
            <Row>
              <Col style={{ width: "50%" }}>
                <p className="io-product-details-title">Product Details</p>
                <div className="io-col-sub-div">
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      AMP Product :
                    </span>
                    {product?.siteNo}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Type :
                    </span>
                    {product?.type}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Title :
                    </span>
                    {product?.title}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Description :
                    </span>
                    {product?.description}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Address 1 :
                    </span>
                    {product?.address}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Address 2 :
                    </span>
                    {`${product?.city}, ${product?.state}, ${product?.zipcode}`}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Country :
                    </span>
                    {product?.country_name}
                  </div>
                  {product?.locationDesc !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Location Description :
                      </span>
                      {product?.locationDesc}
                    </div>
                  )}

                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Unit Quantity :
                    </span>
                    {product?.unitQty}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Height :
                    </span>
                    {product?.height}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Width :
                    </span>
                    {product?.width}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Panel Size :
                    </span>
                    {product?.panelSize}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Available 4-week Periods :
                    </span>
                    {Number(product?.weekPeriod)?.toFixed(2)}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Rate Card (4 weeks) :
                    </span>
                    {formatToUSCurrency(Number(product?.rateCard)?.toFixed(2))}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Fixed/Variable :
                    </span>
                    {product?.fix}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Minimum Days :
                    </span>
                    {product?.minimumdays}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Installation Cost :
                    </span>
                    {formatToUSCurrency(
                      Number(product?.installCost)?.toFixed(2)
                    )}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Production Cost :
                    </span>
                    {formatToUSCurrency(
                      Number(product?.productioncost)?.toFixed(2)
                    )}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Product Direction :
                    </span>
                    {product?.imgdirection}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Illumination :
                    </span>
                    {product?.lighting}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Facing :
                    </span>
                    {product?.direction}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Latitude :
                    </span>
                    {product?.lat}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Longitude :
                    </span>
                    {product?.lng}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Restrictions :
                    </span>
                    {product?.notes}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Cancellation Policy :
                    </span>
                    {product?.cancellation_policy}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Payment Terms :
                    </span>
                    {product?.cancellation_terms}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Median HHI :
                    </span>
                    {product?.mediahhi !== "NaN" &&
                      formatToUSCurrency(Number(product?.mediahhi)?.toFixed(2))}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Impression 18 - 49 :
                    </span>
                    {product?.firstImpression !== "NaN" &&
                      product?.firstImpression}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      CPM Adults 18 - 49 :
                    </span>
                    {product?.firstcpm !== "NaN" &&
                      formatToUSCurrency(Number(product?.firstcpm)?.toFixed(2))}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Impression 18 - Plus :
                    </span>
                    {product?.secondImpression !== "NaN" &&
                      product?.secondImpression}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      CPM Adults 18 - Plus :
                    </span>

                    {product?.cpm !== "NaN" &&
                      formatToUSCurrency(Number(product?.cpm)?.toFixed(2))}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Impression 25 - 54 :
                    </span>
                    {product?.thirdImpression !== "NaN" &&
                      product?.thirdImpression}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      CPM Adults 25 - 54 :
                    </span>
                    {product?.thirdcpm !== "NaN" &&
                      formatToUSCurrency(Number(product?.thirdcpm)?.toFixed(2))}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Impression (HA25 - HA54) :
                    </span>
                    {product?.forthImpression !== "NaN" &&
                      product?.forthImpression}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      CPM Hispanic 25 - 54 :
                    </span>
                    {product?.forthcpm !== "NaN" &&
                      formatToUSCurrency(Number(product?.forthcpm)?.toFixed(2))}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Audited :
                    </span>
                    {product?.audited}
                  </div>
                  <div>
                    <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                      Seller Id :
                    </span>
                    {product?.sellerId}
                  </div>
                  {product?.Comments !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Comments :
                      </span>
                      {product?.Comments}
                    </div>
                  )}
                  {(product?.billingYes !== "" ||
                    product?.billingNo !== "") && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        AMP Bills :
                      </span>
                      {product?.billingYes
                        ? product?.billingYes
                        : product?.billingNo}{" "}
                      {product?.offer_comments_data}
                    </div>
                  )}
                  {(product?.servicingNo !== "" ||
                    product?.servicingYes !== "") && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        AMP Services :
                      </span>
                      {product?.servicingNo
                        ? product?.servicingNo
                        : product?.servicingYes}
                      {product?.offer_comments_data}
                    </div>
                  )}
                  {product?.spotLength !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Spot Length :
                      </span>
                      {product?.spotLength}
                    </div>
                  )}
                  {product?.ageloopLength !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Loop Length :
                      </span>
                      {product?.ageloopLength}
                    </div>
                  )}
                  {product?.fliplength !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Flip Length :
                      </span>
                      {product?.fliplength}
                    </div>
                  )}
                  {product?.medium !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Medium :
                      </span>
                      {product?.medium}
                    </div>
                  )}
                  {product?.product_newAge !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Product :
                      </span>
                      {product?.product_newAge}
                    </div>
                  )}
                  {product?.file_type !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        File Type :
                      </span>
                      {product?.file_type}
                    </div>
                  )}
                  {product?.staticMotion !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Static Motion :
                      </span>
                      {product?.staticMotion}
                    </div>
                  )}
                  {product?.sound !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Sound :
                      </span>
                      {product?.sound}
                    </div>
                  )}
                  {product?.network !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Network :
                      </span>
                      {product?.network}
                    </div>
                  )}
                  {product?.nationloc !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        National Local :
                      </span>
                      {product?.nationloc}
                    </div>
                  )}
                  {product?.daypart !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Day Part :
                      </span>
                      {product?.daypart}
                    </div>
                  )}
                  {product?.genre !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Genre :
                      </span>
                      {product?.genre}
                    </div>
                  )}
                  {product?.costperpoint !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Cost Per Point :
                      </span>
                      {formatToUSCurrency(
                        Number(product?.costperpoint)?.toFixed(2)
                      )}
                    </div>
                  )}
                  {product?.placement !== "" && (
                    <div>
                      <span className="view-io-terms view-io-terms-css-alignment view-io-terms-header view-io-left-alignment">
                        Ad Type :
                      </span>
                      {product?.placement}
                    </div>
                  )}
                </div>
              </Col>
              <Col className="io-image-display-col">
                <Image
                  preview={false}
                  src={`${API_BASE_URL_IMAGE}${product?.image[0]}`}
                ></Image>
                <Image
                  preview={false}
                  src={
                    product?.map_image
                      ? `${API_BASE_URL_IMAGE}${product?.map_image[0]}`
                      : ""
                  }
                ></Image>
              </Col>
            </Row>

            <Col>
              <div
                className="io-footer-text"
                style={{
                  color: "var(--Colors-Primary-500, #d2042d)",
                }}
              >
                Advertising Marketplace, LLC
              </div>
              <span className="io-footer-text">All Rights Reserved</span>
            </Col>
            <Divider className="quote-divider"></Divider>
          </>
        ))}

        <Col className="io-footer-bottom-css">
          <div className="common-css">
            <span className="view-io-terms">
              For any questions, contact us at{" "}
              <a
                style={{ color: "#D2042D" }}
                href="mailto:support@advertisingmarketplace.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                support@advertisingmarketplace.com
              </a>{" "}
            </span>
          </div>
        </Col>
        <div className="tag-line">
          We make advertising easy<sup className="superscript">SM</sup>
        </div>
      </div>
      {pdfLoader && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};
export default CampaignDetailsQuote;
